import React from 'react'
import styled from 'styled-components'
import { GoTriangleDown, GoTriangleUp } from 'react-icons/go'

import { ap_table_header, ar_table_header } from '../constants'
import { FONTS } from '../../../constants'

const renderIcon = (col, sortOrder) => {
  if (sortOrder.col === col) {
    return sortOrder.desc ? <GoTriangleDown /> : <GoTriangleUp />
  }
  return null
}

export const TableHeader = ({ activeTab, sortOrderAP, sortOrderAR, handleSort }) => {
  switch (activeTab) {
    case 0: {
      return (
        <APRow>
          <Col />
          {ap_table_header.map((h, key) => (
            <Col
              key={ key }
              right={ h.right }
              sort={ h.sort }
              onClick={ h.sort ? () => handleSort('ap', h.id) : null }
            >
              { h.title }&nbsp;
              {h.sort && renderIcon(h.id, sortOrderAP)}
            </Col>
          ))}
        </APRow>
      )
    }
    case 1: {
      return (
        <ARRow>
          {ar_table_header.map((h, key) => (
            <Col
              key={ key }
              right={ h.right }
              sort={ h.sort }
              onClick={ h.sort ? () => handleSort('ar', h.id) : null }
            >
              { h.title }&nbsp;
              {h.subtitle && <SubTitle>&nbsp;{ h.subtitle }</SubTitle>}
              {h.sort && renderIcon(h.id, sortOrderAR)}
            </Col>
          ))}
          <Col />
        </ARRow>
      )
    }
    default: return null
  }
}

const APRow = styled.div`
  height: 35px;
  display: grid;
  grid-template-columns: 24px 100px minmax(auto, 250px) minmax(auto, 150px) 1fr 100px 100px 100px 100px 150px;
  grid-gap: 24px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #1A1A17;
  /* cursor: pointer; */
  background: #4F4F4F;
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.SMALL_SIZE};
  color: #FFFFFF;
  padding: 0 24px;
  margin-top: 10px;

  @media (max-width: 1440px) {
    width: fit-content;
    grid-template-columns: 24px 100px 200px 100px 100px 100px 100px 100px 100px 150px;
  }

  @media (max-width: 1024px) {
    width: fit-content;
    grid-template-columns: 24px 100px 150px 100px 100px 100px 100px 100px 100px 150px;
  }
`

const ARRow = styled(APRow)`
  grid-template-columns: minmax(auto, 250px) minmax(auto, 150px) minmax(auto, 150px) 100px 1fr 100px 100px 100px 120px;

  @media (max-width: 1440px) {
    width: fit-content;
    grid-template-columns: 150px 100px 100px 100px 150px 100px 100px 100px 120px;
  }

  @media (max-width: 1024px) {
    width: fit-content;
    grid-template-columns: 150px 100px 100px 100px 150px 100px 100px 100px 120px;
  }
`

const Col = styled.div`
  height: 35px;
  display: flex;
  align-items: center;

  ${p => p.right && `
    justify-content: flex-end;
  `}

${p => p.sort && `
    cursor: pointer;
  `}
`

const SubTitle = styled.span`
  height: 14px;
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #FFFFFF;
`



// WEBPACK FOOTER //
// ./src/components/accounting-dashboard/data-table/table-header.js